module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page-ten-eerste page",
    attrs: {
      "id": "page-ten-eerste"
    }
  }, [_c('div', {
    staticClass: "page__content"
  }, [_c('h1', [_vm._v("HOOGSTE TIJD OM JE EIGEN HYBRIDE DOCENT-PROFIEL TE VORMEN. RECHTS IN BEELD LOOPT JOUW PERSOONLIJKE PROFIEL MEE.")]), _vm._v(" "), _c('div', {
    staticClass: "container list-select"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.jobTypes), function(type) {
    return _c('div', {
      staticClass: "list-select__item row",
      class: {
        'list-select__item--selected': type === _vm.currentJob
      },
      on: {
        "touchstart": function($event) {
          _vm.selectType(type)
        },
        "click": function($event) {
          _vm.selectType(type)
        }
      }
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "col-10-sm list-select__item-text"
    }, [_vm._v("\n                    " + _vm._s(type.label) + "\n                ")])])
  }), _vm._v(" "), (_vm.currentJob) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-2-sm"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-10-sm list-select__title"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "touchstart": _vm.submitHandler,
      "click": _vm.submitHandler
    }
  }, [_vm._v("Volgende")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "result-anchor"
  }), _vm._v(" "), (_vm.submitted) ? _c('p', {
    staticClass: "result-box"
  }, [_vm._v("\n                Oké! Er zijn talloze combinaties mogelijk. Je hebt al gezien dat dé hybride docent niet bestaat. Laten we snel doorgaan met de volgende vraag.\n                "), (_vm.submitted) ? _c('page-next-button', {
    on: {
      "touchstart": _vm.nextHandler,
      "click": _vm.nextHandler
    }
  }) : _vm._e()], 1) : _vm._e()], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-2-sm"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-10-sm list-select__title"
  }, [_vm._v("Ik ben")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-2-sm list-select__item-marker-column"
  }, [_c('div', {
    staticClass: "list-select__item-marker"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35733668","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/page-ten-eerste.vue
// module id = 137
// module chunks = 0